import { OrderList, type OrderListProps } from "primereact/orderlist";
import React from "react";
import styled from "styled-components";

type Props<T> = {
	selectedAttachment: T[];
	template: (c: T) => React.ReactElement;
} & OrderListProps;

const OrderListWithoutControls = styled(OrderList)`
	.p-orderlist-controls {
		display: none;
	}

	.p-orderlist-list {
		.p-disabled {
			opacity: 1;
		}
	}
`;

export function AttachmentPreview<AttachmentType>(props: Props<AttachmentType>) {
	return (
		<OrderListWithoutControls
			{...props}
			className={"mt-2"}
			value={props.selectedAttachment || []}
			dragdrop
			listStyle={{ height: "auto" }}
			itemTemplate={(config: AttachmentType) => props.template(config)}
		/>
	);
}
